import styled from 'styled-components'

export const Container = styled.div`
    height:100vh; 
`
export const Divisor = styled.hr`
    margin-top:0px;
`